var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJunior(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "#171717"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15155_2729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4795 31.0797V36.1042C20.4803 36.275 20.5349 36.4412 20.6354 36.5792C20.7359 36.7173 20.8773 36.8202 21.0396 36.8734C21.2018 36.9266 21.3767 36.9274 21.5395 36.8757C21.7022 36.824 21.8446 36.7224 21.9463 36.5852L24.8854 32.5856L20.4795 31.0797ZM36.6591 12.1507C36.537 12.0637 36.3933 12.0123 36.2438 12.0019C36.0943 11.9916 35.9448 12.0228 35.8119 12.0922L11.4369 24.8213C11.2967 24.8955 11.1811 25.0089 11.1044 25.1478C11.0278 25.2866 10.9933 25.4449 11.0053 25.603C11.0172 25.7612 11.0751 25.9125 11.1718 26.0382C11.2685 26.1639 11.3998 26.2587 11.5496 26.3109L18.3258 28.6271L32.7569 16.2879L21.5899 29.7418L32.9465 33.6234C33.0592 33.6613 33.1788 33.674 33.297 33.6608C33.4151 33.6476 33.5289 33.6087 33.6305 33.5469C33.732 33.4851 33.8188 33.4019 33.8848 33.303C33.9508 33.2041 33.9944 33.092 34.0125 32.9745L36.9917 12.9328C37.0137 12.7845 36.9943 12.6329 36.9356 12.4949C36.877 12.3568 36.7812 12.2377 36.6591 12.1507Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15155_2729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunior);
export default __webpack_public_path__ + "static/media/Junior.60f06720e5f74d9c881df6d18244b85d.svg";
export { ForwardRef as ReactComponent };